import { useMemo } from "react";
import { useFilters } from "../../../filters";
import { createFilterMap } from "../helpers";
import { FilterMap } from "../types";

export const useFilterMap = (): FilterMap => {
  const { entityFilters } = useFilters();
  return useMemo(() => (entityFilters ? createFilterMap(entityFilters) : {}), [entityFilters]);
};
